Vue.component("early-access-cards", {
    props: ["num_invitations", "num_colleague_referrals", "group"],

    template: `
		
		<div>
			<div class="py-4 expanded">
				<h3 class="text-center mb-4">{{ __('Invite your colleague to') }} <span class="blue-text">{{ team.name }}</span></h3>
				<slot name="inv" :team="team" :user="user" billableType="team" :group="group">
				</slot>
				<p class="col-centered w-75 text-center mt-2">
				<small>We recommend inviting your colleagues into the platform. <strong>Note:</strong> By inviting people, you're giving them
				access to this hotel ({{ team.name }})</small><br>
				<a v-if="num_invitations > 0" href="/settings/hotels/1#/membership">See your invitations ({{ num_invitations }} pending)</a>
				</p>
			</div>

		</div>

	`,

    data() {
        return {
            user: Spark.state.user,
            team: Spark.state.currentTeam,
            colleaguesActive: false
        };
    },

    methods: {}
});
